const env = process.env.CF_PAGES_BRANCH ?? 'local';

type Config = {
  apiBaseUrl: string;
  clerk: {
    publishableKey: string;
  };
};

const configMap: Record<string, Config> = {
  // Production (CF Pages production branch = "main", mapped from git "prod")
  prod: {
    apiBaseUrl: 'https://api.petso.io',
    clerk: {
      publishableKey:
        'pk_live_Y2xlcmsucHJvLnBldHNvLmlvJA',
    },
  },

  // Dev
  dev: {
    apiBaseUrl: 'https://api-dev.petso.dev',
    clerk: {
      publishableKey:
        'pk_test_YnVzeS1ob3VuZC03Ny5jbGVyay5hY2NvdW50cy5kZXYk',
    },
  },

  // "main" is the Cloudflare Pages production branch name — maps to dev config
  main: {
    apiBaseUrl: 'https://api-dev.petso.dev',
    clerk: {
      publishableKey:
        'pk_test_YnVzeS1ob3VuZC03Ny5jbGVyay5hY2NvdW50cy5kZXYk',
    },
  },

  // Staging
  staging: {
    apiBaseUrl: 'https://api-dev.petso.dev',
    clerk: {
      publishableKey:
        'pk_test_YnVzeS1ob3VuZC03Ny5jbGVyay5hY2NvdW50cy5kZXYk',
    },
  },

  // Local development
  local: {
    apiBaseUrl: 'http://localhost:8787',
    clerk: {
      publishableKey:
        'pk_test_YnVzeS1ob3VuZC03Ny5jbGVyay5hY2NvdW50cy5kZXYk',
    },
  },
};

export const config = configMap[env] ?? configMap.dev;
